import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import type { CampaignSupplierMonitoringDto } from '@/api/supplier-monitoring-client';
import { useSupplierMonitoringClient } from '@/api/supplier-monitoring-client-context';

// =============================================================================
// use-supplier-monitoring.ts — Hook TanStack Query de la Section « Suivi fournisseurs » (V-SUIVI-FOURN-read).
// =============================================================================
// Une seule lecture (useQuery) — aucune mutation (admin LIT, invariant n°1). Le client effectif vient du
// SupplierMonitoringClientProvider (doublable, stub-first). ZÉRO règle métier ici : l'autorité (RBAC
// AdminSessionGuard, withAdmin, composition EN MÉMOIRE via ports ACL, badge >48h, agrégat SIREN) est l'API.

const SUPPLIER_MONITORING_KEY = ['supplier-monitoring'] as const;

/** Section « Suivi fournisseurs » d'une campagne (table SIRET + agrégats SIREN). */
export function useSupplierMonitoring(
  campaignId: string,
): UseQueryResult<CampaignSupplierMonitoringDto> {
  const client = useSupplierMonitoringClient();
  return useQuery({
    queryKey: [...SUPPLIER_MONITORING_KEY, campaignId],
    queryFn: () => client.getSupplierMonitoring(campaignId),
  });
}
